import { FC, useState, useEffect } from 'react';

import { Popup } from '@silverfort/sf-components';

import ResolutionFeedbackFooter from './ResolutionFeedbackFooter';
import { StatusMeta } from './types';
import ResolutionFeedbackContent from './ResolutionFeedbackContent';
import { INSIGHT_STATUS_DESCRIPTIONS } from '@silverfort-nodelibs/common/utils/consts';

type ResolutionFeedbackPopupProps = {
    isOpen: boolean;
    handleStatusChange: (newStatus: string, newStatusDescription: string) => void;
    onClose: () => void;
    selectedInsightStatusDescription?: string;
}

export function ResolutionFeedbackPopup({ isOpen, onClose, handleStatusChange, selectedInsightStatusDescription }: ResolutionFeedbackPopupProps) {
    const [selectedStatus, setSelectedStatus] = useState<StatusMeta>();

    useEffect(() => {
        if (selectedInsightStatusDescription) {
            if (selectedInsightStatusDescription === INSIGHT_STATUS_DESCRIPTIONS.RESOLVED) {
                setSelectedStatus({status: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED, statusDescription: INSIGHT_STATUS_DESCRIPTIONS.MITIGATED});
                return;
            }
            setSelectedStatus({status: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED, statusDescription: selectedInsightStatusDescription});
        }
    }, []);
    
    const onStatusSubmit = () => {
        if (selectedStatus) {
            if (selectedStatus.statusDescription !== selectedInsightStatusDescription) {
                handleStatusChange(selectedStatus.status, selectedStatus.statusDescription);
            }
            onClose();
        }
    };

    return (
        <Popup
            className={'z-[11000]'}
            open={isOpen}
            title="Resolution Feedback"
            ContentComponent={ResolutionFeedbackContent}
            ContentComponentProps={{ selectedStatus, setSelectedStatus }}
            FooterComponent={ResolutionFeedbackFooter}
            FooterComponentProps={{ isOptionSelected: !!selectedStatus, onStatusSubmit, onClose }}
            onClose={onClose}
        />
    );
};

